import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import ResponsiveImage from 'components/images/responsive-image'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { toggleBodyFreezing } from 'lib/utils/common/commonUtils'
import env from 'config/env'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import SizeTable from 'components/common/size-table'
import { withI18next } from 'lib/i18n/withI18next'
import {
  SIZE_GUIDES_IMAGE_URL,
  SIZE_GUIDES_TABLE,
  SIZE_GUIDES_INFO,
  SIZE_GUIDES_TABLE_NEWSIZE,
} from './const'
import styles from './styles.scss'
import SizesGuidesInfomation from '../size-guide-infomation'

const SizesGuideModal = ({ isPhone, onClose, t, isNewSize }) => {
  const classHeader = clsx('sizes-guide__header', {
    margin__header: isPhone,
  })
  const tableData = isNewSize ? SIZE_GUIDES_TABLE_NEWSIZE : SIZE_GUIDES_TABLE
  useEffect(() => {
    if (isPhone) {
      toggleBodyFreezing(true)
    }

    return () => {
      toggleBodyFreezing(false)
    }
  }, [isPhone])

  return (
    <div className="sizes-guide__modal">
      <style jsx>{styles}</style>
      <div className={classHeader}>
        <Icon
          alt="size guide modal close btn"
          className="icon-close"
          onClick={onClose}
          src={ICONS.close}
          size={ICON_SIZE.medium}
        />
        {isPhone && (
          <span className={Typo.subtitle1}>
            {hasLocizeTranslation(t, 'PDP_SIZE_GUIDE_LABEL', 'Size Guide')}
          </span>
        )}
      </div>
      <div className="sizes-guide__info-container">
        {isNewSize && (
          <div className="new-size__container">
            <div>
              <img
                className="icon-newarrivals"
                src={ICONS.newArrivals}
                alt="icon-newarrivals"
              />
            </div>
            <div className="new-size__content">
              <span className={clsx('new-size__title', Typo.subtitle2)}>
                {hasLocizeTranslation(
                  t,
                  SIZE_GUIDES_INFO.newSizeTitle.titleKey,
                  SIZE_GUIDES_INFO.newSizeTitle.default,
                )}
              </span>
              <span className={Typo.caption}>
                {hasLocizeTranslation(
                  t,
                  SIZE_GUIDES_INFO.newSizeDescription.titleKey,
                  SIZE_GUIDES_INFO.newSizeDescription.default,
                )}
              </span>
            </div>
          </div>
        )}
        <span className={Typo.subtitle1}>
          {hasLocizeTranslation(
            t,
            SIZE_GUIDES_INFO.title.titleKey,
            SIZE_GUIDES_INFO.title.default,
          )}
        </span>
        <span
          className={clsx('sizes-guide__info-container__content', Typo.body2)}
        >
          {hasLocizeTranslation(
            t,
            SIZE_GUIDES_INFO.description.titleKey,
            SIZE_GUIDES_INFO.description.default,
          )}
        </span>
        <SizesGuidesInfomation />
        <ResponsiveImage
          className="sizes-guide__image"
          src={`${env.IMG_HOST}${SIZE_GUIDES_IMAGE_URL}`}
          tablet="40vw"
          laptop="40vw"
          desktop="40vw"
          bigDesktop="40vw"
        />
        <div className="sizes-guide__units-container">
          <span className={Typo.subtitle1}>
            {hasLocizeTranslation(
              t,
              SIZE_GUIDES_INFO.unitTitle.titleKey,
              SIZE_GUIDES_INFO.unitTitle.default,
            )}
          </span>
        </div>
        <SizeTable
          columns={tableData.columns}
          rows={tableData.rows}
          isSizeGuideDialog
          isPhone
        />
      </div>
    </div>
  )
}

SizesGuideModal.defaultProps = {
  isNewSize: false,
}

SizesGuideModal.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isNewSize: PropTypes.bool,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(SizesGuideModal)
